import { IconArrowsArrowRight } from '@doltech/icons/IconArrowsArrowRight';
import { TestModeEnum } from '@doltech/utils/lib/constants';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { QuestionCircle, QuestionDisplayMode } from '../CircleText/CircleText';

import { ResponsiveTypography } from '../Typography/v3/ResponsiveTypography';
import { DoTestEditor } from '../DoTestEditor/DoTestEditor';
import { isJson } from '@doltech/utils/lib/object';
import { FontSizeElementVariants } from '../DolEditor/decorators/font-size-switcher/components/FontSizeSwitcherElement.types';

interface QuestionV2Props extends React.HTMLAttributes<HTMLDivElement> {
  no: number | string;
  withDot?: boolean;
  content?: string;
  noArrow?: boolean;
  marginRight?: number;
  testMode?: TestModeEnum | string;
  className?: string;
  onChangeQuestion?: (value: string) => void;
}

export const QuestionV2 = (props: QuestionV2Props) => {
  const {
    no,
    withDot = false,
    content,
    noArrow,
    marginRight,
    testMode,
    className,
    onChangeQuestion,
    ...rest
  } = props;

  if (testMode === TestModeEnum.VIEW_TEST_QUESTION) {
    return (
      <QuestionCircle className={cl(QuestionDisplayMode.QUESTION_NO_VIEW_SUBJECT)}>
        <ResponsiveTypography.Text variant="regular/14-20">{no}</ResponsiveTypography.Text>
      </QuestionCircle>
    );
  }

  return (
    <QuestionWrapper
      $noArrow={noArrow}
      className={cl(className, 'question-wrapper', { 'question-inline': withDot })}
      {...rest}
    >
      {withDot ? (
        <TextNo>
          <ResponsiveTypography.Text variant="bold/14" color="blue100">
            {no}
          </ResponsiveTypography.Text>
          <ResponsiveTypography.Text variant="bold/14" color="blue40">
            .
          </ResponsiveTypography.Text>
        </TextNo>
      ) : (
        <ResponsiveTypography.Text variant="bold/16" color="blue100">
          {no}
        </ResponsiveTypography.Text>
      )}

      {!noArrow && <IconArrowsArrowRight fontSize={18} color="blue100" />}
      {content && (
        <ResponsiveTypography.Text
          variant="semi-bold/14"
          className={cl('question-content', { 'question-content-inline': withDot })}
          color="black100"
        >
          <DoTestEditor
            readOnly
            initialValue={
              isJson(content)
                ? JSON.parse(content)
                : [
                    {
                      type: FontSizeElementVariants.PARAGRAPH,
                      children: [
                        {
                          text: content ?? '',
                        },
                      ],
                    },
                  ]
            }
            onChange={onChangeQuestion}
          />
        </ResponsiveTypography.Text>
      )}
    </QuestionWrapper>
  );
};

export const QuestionWrapper = styled.span<{ $noArrow?: boolean }>`
  max-width: 100%;
  display: grid;
  grid-auto-flow: column;
  text-align: left;
  grid-template-columns: ${(p) =>
    p.$noArrow ? 'max-content minmax(0, 1fr)' : 'max-content max-content minmax(0, 1fr)'};
  column-gap: 4px;
  align-items: center;
  &.with-mr {
    margin-right: 12px;
  }

  .question-content {
    margin-left: 8px;
  }

  &.question-inline {
    display: block;
  }

  .question-content-inline {
    * {
      display: inline;
    }
  }
  svg {
    opacity: 0.5;
  }
`;

const TextNo = styled.div`
  display: inline;
  margin-right: 4px;
`;
